export class ParticipacaoConselhoRequestDto{
     nomeConselho: string;
     orgaoVinculado: string;
     mandatoInicio: string;
     mandatoFim: string;
     idFormaParticipacao: number;
     idOrigem: number;
     idTipoParticipacao: number;
     leiAtoNormaCriacao: string;
     funcao: string;
}
